import NotificationBadge, {
  NotificationBadgeOpts,
} from 'src/game/components/shared/NotificationBadge';
import { whileInHierarchy } from 'src/lib/utils';
import { updateFriendsFooterNotificationBadge } from './footer.utils';

export default class FooterFriendsBadge extends NotificationBadge {
  constructor(opts: NotificationBadgeOpts) {
    super(opts);
    this.hide();
    void whileInHierarchy(this, (stop) =>
      updateFriendsFooterNotificationBadge(stop, this, true),
    );
  }
}
